export const getPdfImageFormat = (dataUrl) => {
  const match = /^data:image\/(png|jpe?g|webp);/i.exec(dataUrl || "")
  if (!match) return "PNG"
  const ext = match[1].toLowerCase()
  if (ext === "jpg" || ext === "jpeg") return "JPEG"
  if (ext === "webp") return "WEBP"
  return "PNG"
}

export const drawPdfLogo = ({
  doc,
  logoBase64,
  x = 20,
  y = 20,
  maxW = 90,
  maxH = 42,
}) => {
  if (!doc || !logoBase64) {
    return { width: 0, height: 0 }
  }

  try {
    const props = doc.getImageProperties(logoBase64)
    const width = Number(props?.width)
    const height = Number(props?.height)
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
      return { width: 0, height: 0 }
    }

    const ratio = Math.min(maxW / width, maxH / height)
    const logoW = width * ratio
    const logoH = height * ratio

    doc.addImage(logoBase64, getPdfImageFormat(logoBase64), x, y, logoW, logoH)
    return { width: logoW, height: logoH }
  } catch (error) {
    return { width: 0, height: 0 }
  }
}
